module.exports = __webpack_public_path__ + "img/other.61b5bdd.png";